import { render, staticRenderFns } from "./picBase.vue?vue&type=template&id=3ecf8887&scoped=true"
import script from "./picBase.vue?vue&type=script&lang=js"
export * from "./picBase.vue?vue&type=script&lang=js"
import style0 from "./picBase.vue?vue&type=style&index=0&id=3ecf8887&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf8887",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ecf8887')) {
      api.createRecord('3ecf8887', component.options)
    } else {
      api.reload('3ecf8887', component.options)
    }
    module.hot.accept("./picBase.vue?vue&type=template&id=3ecf8887&scoped=true", function () {
      api.rerender('3ecf8887', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseTemplate/picBase.vue"
export default component.exports